import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69dbecefa74957001422807b_1787705630798_78027dc8/silverprompt/src/app/updates/page.tsx");
